/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvalScheduleOverlapPolicy,
  EvalScheduleOverlapPolicy$inboundSchema,
  EvalScheduleOverlapPolicy$outboundSchema,
} from "./evalscheduleoverlappolicy.js";
import {
  EvalScheduleRunConfig,
  EvalScheduleRunConfig$inboundSchema,
  EvalScheduleRunConfig$Outbound,
  EvalScheduleRunConfig$outboundSchema,
} from "./evalschedulerunconfig.js";

export type UpdateEvalScheduleRequest = {
  name?: string | undefined;
  description?: string | null | undefined;
  suiteVersion?: number | null | undefined;
  cron?: string | null | undefined;
  intervalSeconds?: number | null | undefined;
  timezone?: string | undefined;
  overlapPolicy?: EvalScheduleOverlapPolicy | undefined;
  enabled?: boolean | undefined;
  webhookUrl?: string | null | undefined;
  webhookSecret?: string | null | undefined;
  run?: EvalScheduleRunConfig | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const UpdateEvalScheduleRequest$inboundSchema: z.ZodType<
  UpdateEvalScheduleRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string().optional(),
  description: z.nullable(z.string()).optional(),
  suite_version: z.nullable(z.number().int()).optional(),
  cron: z.nullable(z.string()).optional(),
  interval_seconds: z.nullable(z.number().int()).optional(),
  timezone: z.string().optional(),
  overlap_policy: EvalScheduleOverlapPolicy$inboundSchema.optional(),
  enabled: z.boolean().optional(),
  webhook_url: z.nullable(z.string()).optional(),
  webhook_secret: z.nullable(z.string()).optional(),
  run: EvalScheduleRunConfig$inboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "suite_version": "suiteVersion",
    "interval_seconds": "intervalSeconds",
    "overlap_policy": "overlapPolicy",
    "webhook_url": "webhookUrl",
    "webhook_secret": "webhookSecret",
  });
});
/** @internal */
export type UpdateEvalScheduleRequest$Outbound = {
  name?: string | undefined;
  description?: string | null | undefined;
  suite_version?: number | null | undefined;
  cron?: string | null | undefined;
  interval_seconds?: number | null | undefined;
  timezone?: string | undefined;
  overlap_policy?: string | undefined;
  enabled?: boolean | undefined;
  webhook_url?: string | null | undefined;
  webhook_secret?: string | null | undefined;
  run?: EvalScheduleRunConfig$Outbound | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const UpdateEvalScheduleRequest$outboundSchema: z.ZodType<
  UpdateEvalScheduleRequest$Outbound,
  z.ZodTypeDef,
  UpdateEvalScheduleRequest
> = z.object({
  name: z.string().optional(),
  description: z.nullable(z.string()).optional(),
  suiteVersion: z.nullable(z.number().int()).optional(),
  cron: z.nullable(z.string()).optional(),
  intervalSeconds: z.nullable(z.number().int()).optional(),
  timezone: z.string().optional(),
  overlapPolicy: EvalScheduleOverlapPolicy$outboundSchema.optional(),
  enabled: z.boolean().optional(),
  webhookUrl: z.nullable(z.string()).optional(),
  webhookSecret: z.nullable(z.string()).optional(),
  run: EvalScheduleRunConfig$outboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    suiteVersion: "suite_version",
    intervalSeconds: "interval_seconds",
    overlapPolicy: "overlap_policy",
    webhookUrl: "webhook_url",
    webhookSecret: "webhook_secret",
  });
});

export function updateEvalScheduleRequestToJSON(
  updateEvalScheduleRequest: UpdateEvalScheduleRequest,
): string {
  return JSON.stringify(
    UpdateEvalScheduleRequest$outboundSchema.parse(updateEvalScheduleRequest),
  );
}
export function updateEvalScheduleRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateEvalScheduleRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateEvalScheduleRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateEvalScheduleRequest' from JSON`,
  );
}
